import { cn } from '@/lib/utils'
import { forwardRef, type InputHTMLAttributes } from 'react'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, 'aria-invalid': ariaInvalid, ...props }, ref) => {
    return (
      <input
        type={type}
        aria-invalid={ariaInvalid}
        className={cn(
          'flex h-10 w-full rounded-[var(--radius-sm)] px-4 text-sm',
          'bg-bg-surface text-text-primary',
          'border border-border',
          'placeholder:text-text-muted',
          'transition-all duration-150',
          'hover:border-border-hover',
          'focus-visible:border-border-accent focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none',
          'focus:outline-none',
          'aria-[invalid=true]:border-error aria-[invalid=true]:focus-visible:ring-error/40',
          'disabled:opacity-40 disabled:pointer-events-none',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'
